import { parseCommentAnchor } from "@hightouch/lib/llm/asset-comments/types";

export function slideCommentLabel(
  value: unknown,
  slideIds: readonly string[],
): string {
  const anchor = parseCommentAnchor(value);
  if (anchor?.kind !== "slide") return "Whole presentation";
  const index = slideIds.indexOf(anchor.slideId);
  return index === -1 ? "Slide removed" : `Slide ${index + 1}`;
}
